import { render, staticRenderFns } from "./SosShiftCard.vue?vue&type=template&id=88549a6c&scoped=true&lang=pug"
import script from "./SosShiftCard.vue?vue&type=script&lang=js"
export * from "./SosShiftCard.vue?vue&type=script&lang=js"
import style0 from "./SosShiftCard.vue?vue&type=style&index=0&id=88549a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88549a6c",
  null
  
)

export default component.exports